import { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import PosLayout from "../POS/PosLayout";
import { all_routes } from "./all_routes";
import HeaderLayouts, { Preloader } from "./headerLayout";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";
import { pagesRoute, posRoutes, publicRoutes } from "./router.link";

// Define role access mapping
export const routeRolesMap = {
  // 👑 Admin only
  [all_routes.partlist]: ["Admin", "Manager", "Employee"],
  [all_routes.addpart]: ["Admin", "Manager", "Employee"],
  [all_routes.addcategory]: ["Admin"],
  [all_routes.addcustomer]: ["Admin", "Manager", "Employee"],
  [all_routes.adduser]: ["Admin"],
  [all_routes.partsmodels]: ["Admin", "Manager"],

  // 👷 Employee
  [all_routes.shop]: ["Employee", "Admin"],
  [all_routes.orderhistory]: ["Employee", "Admin"],
  [all_routes.neworders]: ["Employee", "Admin", "Manager"],

  // 👔 Manager
  [all_routes.productlist]: ["Manager", "Admin"],
  [all_routes.addtransport]: ["Manager", "Admin"],
  [all_routes.discounts]: ["Manager", "Admin"],

  // Shared between multiple roles
  [all_routes.pos]: ["Admin", "Manager", "Employee"],
  [all_routes.allorder]: ["Admin", "Manager", "Employee"],
  [all_routes.product]: ["Admin", "Manager", "Employee"],
  [all_routes.categorylist]: ["Admin", "Manager"],
  [all_routes.customerlist]: ["Admin", "Manager", "Employee"],
  [all_routes.transportlist]: ["Admin", "Manager"],
  [all_routes.brandlist]: ["Admin", "Manager"],
  [all_routes.inventory]: ["Admin", "Manager"],
  [all_routes.managestock]: ["Admin", "Manager"],
  [all_routes.lowstock]: ["Admin", "Manager"],
  [all_routes.onlineorder]: ["Admin"],
  [all_routes.invoice]: ["Admin"],
  [all_routes.purchaseorder]: ["Admin"],
  [all_routes.invoicedetails]: ["Admin"],
  [all_routes.salesreturn]: ["Admin"],
  [all_routes.salesreport]: ["Admin", "Manager"],
  [all_routes.purchasereport]: ["Admin", "Manager"],
  // [all_routes.inventoryreport]: ["Admin", "Manager", "Employee"],
  [all_routes.stockhistory]: ["Admin"],
  [all_routes.soldstock]: ["Admin"],
  [all_routes.customerreport]: ["Admin"],
  // [all_routes.productreport]: ["Admin", "Manager", "Employee"],
  // [all_routes.productexpiredreport]: ["Admin"],
  // [all_routes.productquantityreport]: ["Admin"],
  // [all_routes.expensereport]: ["Admin"],
  // [all_routes.incomereport]: ["Admin"],
  // [all_routes.taxreport]: ["Admin", "Manager"],
  [all_routes.profitloss]: ["Admin"],
  [all_routes.accounting]: ["Admin", "Manager"],
  [all_routes.addvendors]: ["Admin", "Manager"],
  [all_routes.addstocks]: ["Admin", "Manager", "Employee"],
  [all_routes.printstocks]: ["Admin", "Manager"],
};

// Roles lookup function
const getRolesByPath = (path) => {
  return routeRolesMap[path] || ["Admin", "Manager", "Employee"];
};

const AllRoutes = () => {
  return (
    <Suspense fallback={<Preloader />}>
      <Routes>
        {/* Root redirect */}
        <Route
          path="/"
          element={
            localStorage.getItem("token") ? (
              <Navigate to="/index" replace />
            ) : (
              <Navigate to="/signin" replace />
            )
          }
        />
        {/* Public routes - accessible without authentication */}
        <Route element={<PublicRoute />}>
          {pagesRoute.map((route, id) => (
            <Route path={route.path} element={route.element} key={id} />
          ))}
        </Route>

        {/* Protected routes - require authentication */}
        <Route element={<HeaderLayouts />}>
          {publicRoutes.map((route, id) => {
            const allowedRoles = getRolesByPath(route.path);
            return (
              <Route
                key={id}
                path={route.path}
                element={
                  <ProtectedRoute allowedRoles={allowedRoles}>
                    {route.element}
                  </ProtectedRoute>
                }
              />
            );
          })}
        </Route>

        <Route element={<PosLayout />}>
          {posRoutes.map((route, id) => {
            const allowedRoles = getRolesByPath(route.path);
            return (
              <Route
                key={id}
                path={route.path}
                element={
                  <ProtectedRoute allowedRoles={allowedRoles}>
                    {route.element}
                  </ProtectedRoute>
                }
              />
            );
          })}
        </Route>
      </Routes>
    </Suspense>
  );
};

export default AllRoutes;
